export interface DiagnosticCheckoutSessionCreateParams {
  product_slug: string;
}

export interface DiagnosticCheckoutSessionCreateResponse {
  session_id: string;
  stripe_checkout_url: string;
}

export const diagnosticCheckoutSessionsCreateQuery = (
  params: DiagnosticCheckoutSessionCreateParams
) => ({
  url: "/api/v1/diagnostics/diagnostic_checkout_sessions",
  method: "POST" as const,
  body: params,
});